module.exports = __webpack_public_path__ + "static/media/featureFilmText.1288d115.svg";